import React from "react";
import { Link, Navigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useAuth } from "../contexts/AuthContext";
import { LogIn } from "lucide-react";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function Login() {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (user && user.role !== "pending") {
    return <Navigate to="/internal/dashboard" replace />;
  }

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/internal/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="grain min-h-screen">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="panel-elev p-8">
          <div className="tick-label text-sky-400 mb-3">/ Internal Operations Center</div>
          <h1 className="font-display font-black text-2xl text-slate-100 mb-2">
            Sign in to continue
          </h1>
          <p className="text-sm text-slate-400 mb-6">
            Authorized GovBidIQ team members sign in with Google. Customer accounts are not used for the internal operations area.
          </p>
          <button
            data-testid="login-google-btn"
            onClick={handleLogin}
            className="w-full inline-flex items-center justify-center gap-3 bg-sky-500 hover:bg-sky-400 text-slate-950 font-mono text-xs tracking-[0.2em] uppercase font-bold px-5 py-3.5 transition-colors"
          >
            <LogIn className="w-4 h-4" strokeWidth={2.5} /> Sign in with Google
          </button>
          {user && user.role === "pending" && (
            <div className="mt-6 border-l-2 border-amber-500 bg-amber-500/5 p-4">
              <div className="tick-label text-amber-400 mb-1">/ Pending approval</div>
              <p className="text-sm text-slate-200">
                You&apos;re signed in as <span className="font-mono">{user.email}</span> but your account has not been granted a role. Ask the CEO to promote you.
              </p>
            </div>
          )}
          <p className="text-[10px] tracking-widest uppercase text-slate-500 font-mono mt-6">
            Customer access is via paid token at <Link to="/run-analysis" className="text-sky-400">/run-analysis</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
